module.exports = __webpack_public_path__ + "static/media/sweartaker.226903fa.jpg";